module.exports = __webpack_public_path__ + "media/images/mail_template/bar_top-fb91d9ffa0464b16fd918d60e6516b4a.png";